<div class="row" *ngIf="Typeofpatient">
  <div class="col-md-12">
    <div class="card input-style">
      <div class="card-header background-white pad1">
        <div class="row">
          <div class="col-md-3">
            <label class="title font-size-20px margin-top-0px float-left margin-bottom-0px label-color-kn">Book Appointment</label>
          </div>
          <div class="offset-md-6 col-md-3">
            <label class="title font-size-14px margin-top-0px margin-bottom-0px labcolor">(Step 1 of 4)</label>
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body background-white">
        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px">
          <div class="row">
            <div class="offset-md-2 col-md-5 col-xl-5 margin-right-0px">
              <div class="row">
                <label class="font-size-18px margin-left-14px margin-top-10">Please Select type of Patient</label>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="offset-md-2 col-md-9 col-xl-9 margin-right-0px margin-top-20px">

              <label class="radio-inline margin-right-30px">

                Registered patient <a class="nav-link-hand margin-left-5px" (click)="regpatient()"> <input type="radio"> </a>
              </label>
              <label class="radio-inline margin-left-35px ">
                Guest/New patient <a class="nav-link-hand margin-left-5px" (click)="guestpatient()"> <input type="radio"> </a>
              </label>

            </div>

          </div>

        </div>

      </div>
      <div class="row margin-top-10 margin-bottom-30px">


        <div class="col-md-12 padding-left-0px padding-right-24px">
          <button class="btn bs hover1 nav-link-hand font-size-16px width float-right" (click)="activeModal.dismiss('Cross click')" type="button">Cancel</button>
        </div>


      </div>
    </div>
  </div>
</div>


<div class="row" *ngIf="Patientlist">
  <div class="col-md-12">
    <div class="card my-profile-form">
      <div class="card-header background-white padding-top-6px padding-bottom-6px">
        <div class="row">
          <div class="col-md-4 padding-left-0px">
            <label class="float-left margin-left-10px title font-size-20px label-color-kn">Registered Patients</label>
          </div>
          <div class="offset-md-5 col-md-3">
            <label class="title font-size-14px margin-top-0px margin-bottom-0px labcolor">(Step 2 of 4)</label>
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>



        </div>
        <div class="row">
          <input type="search" class="form-control padding-bottom-2px width-656px margin-left-10px float-right" placeholder="Search....">
        </div>

      </div>
      <div class="card-body padding-top-0px padding-bottom-10px">

        <div class="table-component b1">
          <div class="table-responsive overflow-x">


            <table class="table table-striped margin-left-zero"
                   cols="auto,2*,*,*,*,*,*,*">

              <thead class="">
                <tr>

                  <th class="padding-top-4px padding-bottom-4px">

                  </th>

                  <th class="padding-top-4px padding-bottom-4px">
                    PID
                  </th>


                  <th class="padding-top-4px padding-bottom-4px">
                    Name
                  </th>
                  <th class="padding-top-4px padding-bottom-4px">
                    Reg date
                  </th>

                  <th class="padding-top-4px padding-bottom-4px">
                    Age
                  </th>

                  <th class="padding-top-4px padding-bottom-4px">
                    Sex
                  </th>
                  <th class="padding-top-4px padding-bottom-4px">
                    Phone
                  </th>



                </tr>
              </thead>

              <tbody class="table-body">
                <tr>
                  <td class="padding-top-4px padding-bottom-4px"><button class="btn btn-primary width3 padding-bottom-0px padding-top-0px hover1 nav-link-hand font-size-14px" (click)="regconfirm()" type="button">Select</button></td>
                  <td class="padding-top-4px padding-bottom-4px">1024</td>
                  <td class="padding-top-4px padding-bottom-4px">B.Vikram Adithya</td>
                  <td class="padding-top-4px padding-bottom-4px">
                    24-05-2019
                  </td>
                  <td class="padding-top-4px padding-bottom-4px">45 Years</td>
                  <td class="padding-top-4px padding-bottom-4px">Male</td>
                  <td class="padding-top-4px padding-bottom-4px">8801667136</td>


                </tr>

                <tr>
                  <td class="padding-top-4px padding-bottom-4px"><button class="btn btn-primary width3 padding-bottom-0px padding-top-0px hover1 nav-link-hand font-size-14px" (click)="regconfirm()" type="button">Select</button></td>
                  <td class="padding-top-4px padding-bottom-4px">1024</td>
                  <td class="padding-top-4px padding-bottom-4px">B.Vikram Adithya</td>
                  <td class="padding-top-4px padding-bottom-4px">
                    24-05-2019
                  </td>
                  <td class="padding-top-4px padding-bottom-4px">45 Years</td>
                  <td class="padding-top-4px padding-bottom-4px">Male</td>
                  <td class="padding-top-4px padding-bottom-4px">8801667136</td>


                </tr>

                <tr>
                  <td class="padding-top-4px padding-bottom-4px"><button class="btn btn-primary width3 padding-bottom-0px padding-top-0px hover1 nav-link-hand font-size-14px" (click)="regconfirm()" type="button">Select</button></td>
                  <td class="padding-top-4px padding-bottom-4px">1024</td>
                  <td class="padding-top-4px padding-bottom-4px">B.Vikram Adithya</td>
                  <td class="padding-top-4px padding-bottom-4px">
                    24-05-2019
                  </td>
                  <td class="padding-top-4px padding-bottom-4px">45 Years</td>
                  <td class="padding-top-4px padding-bottom-4px">Male</td>
                  <td class="padding-top-4px padding-bottom-4px">8801667136</td>


                </tr>

                <tr>
                  <td class="padding-top-4px padding-bottom-4px"><button class="btn btn-primary width3 padding-bottom-0px padding-top-0px hover1 nav-link-hand font-size-14px" (click)="regconfirm()" type="button">Select</button></td>
                  <td class="padding-top-4px padding-bottom-4px">1024</td>
                  <td class="padding-top-4px padding-bottom-4px">B.Vikram Adithya</td>
                  <td class="padding-top-4px padding-bottom-4px">
                    24-05-2019
                  </td>
                  <td class="padding-top-4px padding-bottom-4px">45 Years</td>
                  <td class="padding-top-4px padding-bottom-4px">Male</td>
                  <td class="padding-top-4px padding-bottom-4px">8801667136</td>


                </tr>

                <tr>
                  <td class="padding-top-4px padding-bottom-4px"><button class="btn btn-primary width3 padding-bottom-0px padding-top-0px hover1 nav-link-hand font-size-14px" (click)="regconfirm()" type="button">Select</button></td>
                  <td class="padding-top-4px padding-bottom-4px">1024</td>
                  <td class="padding-top-4px padding-bottom-4px">B.Vikram Adithya</td>
                  <td class="padding-top-4px padding-bottom-4px">
                    24-05-2019
                  </td>
                  <td class="padding-top-4px padding-bottom-4px">45 Years</td>
                  <td class="padding-top-4px padding-bottom-4px">Male</td>
                  <td class="padding-top-4px padding-bottom-4px">8801667136</td>


                </tr>














              </tbody>

            </table>
          </div>
        </div>
      </div>
      <div class="row margin-top-10 margin-bottom-30px">


        <div class="col-md-6 padding-left-0px padding-right-24px">
          <button class="btn bs hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px float-right" (click)="Back1()" type="button">Back</button>
        </div>
        <div class="col-md-6 padding-left-0px padding-right-24px">
          <button class="btn bs hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px padding-left-8px float-left" (click)="activeModal.dismiss('Cross click')" type="button">Cancel</button>
        </div>


      </div>
    </div>
  </div>
</div>


<div class="row margin-right-0px" *ngIf="Regconfirm">
  <div class="col-md-12 padding-right-0px background-white">
    <div class="card">
      <div class="card-header background-white pad1">

        <div class="row margin-bottom-8px">
          <div class="col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3 padding-top-15px">
            <div class="row a1">
              <label class="margin-bottom-0px f2">Dr.Sitharam</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">Cardiologist</label>
            </div>

          </div>
          <div class="offset-md-4 col-md-3">
            <label class="title font-size-14px margin-top-0px margin-bottom-0px labcolor">(Step 3 of 4)</label>
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

        </div>


      </div>

      <div class="card-body background-white padding-left-0px padding-top-0px">


        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px margin-bottom-10px">

          <div class="row">
            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px c3">
              <div class="row">
                <div class="col-md-12 padh1 padding-left-15px">

                  <div class="row">

                    <div class="col-md-4">
                      <div class="row a1">
                        <label class="margin-bottom-0px f2">Appointment</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-0px">24-May-2019</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-5px">11:15 A.M</label>
                      </div>
                    </div>

                    <div class="col-md-4 paddin-left-5px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px">B.Vikram Adithya</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px">Male, 45 Years</label>
                      </div>
                    </div>

                    <div class="col-md-4 padding-left-0px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient Contact</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px"><i class="fas fa-phone"></i> : 8801667136</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px"><i class="fas fa-envelope"></i> : vikramadithya&#64;healins.com</label>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>


            <!--<div class="col-md-12 padding-left-0px">
              <div class="row">
                <div class="col-md-6">
                  <button class="btn btn-primary hover1 nav-link-hand font-size-16px width float-right margin-top-30px margin-left-45px" (click)="Confirm()" type="button">Book</button>

                </div>
                <div class="col-md-6">
                  <button class="btn bs hover1 nav-link-hand font-size-16px width float-left margin-top-30px margin-left-45px" (click)="activeModal.dismiss('Cross click')" type="button">Back</button>

                </div>


              </div>
            </div>-->
            <div class="col-md-12">
              <div class="row margin-top-30px margin-bottom-30px">

                <div class="col-md-6 padding-left-0px padding-right-24px">
                  <button class="btn bs hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px float-right" (click)="Back2()" type="button">Back</button>
                </div>
                <div class="col-md-6 padding-left-0px padding-right-24px">
                  <button class="btn btn-primary hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px float-left" (click)="Confirm()" type="button">Book</button>
                </div>

              </div>

            </div>


          </div>

        </div>
      </div>
    </div>

  </div>

</div>


<div class="row margin-right-0px" *ngIf="Final">
  <div class="col-md-12 padding-right-0px background-white">
    <div class="card">
      <div class="card-header background-white pad1">

        <div class="row margin-bottom-8px">
          <div class="col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3 padding-top-15px">
            <div class="row a1">
              <label class="margin-bottom-0px f2">Dr.Sitharam</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">Cardiologist</label>
            </div>

          </div>
          <div class="offset-md-4 col-md-3">
            <label class="title font-size-14px margin-top-0px margin-bottom-0px labcolor">(Step 4 of 4)</label>
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

        </div>


      </div>

      <div class="card-body background-white padding-left-0px padding-top-0px">


        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px margin-bottom-10px">

          <div class="row">
            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px c3">
              <div class="row">
                <div class="col-md-12 padding-left-15px padh1">

                  <div class="row">

                    <div class="col-md-4">
                      <div class="row a1">
                        <label class="margin-bottom-0px f2">Appointment</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-0px">24-May-2019</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-5px">11:15 A.M</label>
                      </div>
                    </div>

                    <div class="col-md-4 paddin-left-5px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px">B.Vikram Adithya</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px">Male, 45 Years</label>
                      </div>
                    </div>

                    <div class="col-md-4 padding-left-0px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient Contact</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px"><i class="fas fa-phone"></i> : 8801667136</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px"><i class="fas fa-envelope"></i> : vikramadithya&#64;healins.com</label>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div class="offset-md-3 col-md-9 padding-left-0px">

              <div class="row">
                <label class="font-size-20px margin-left-22px margin-top-30px margin-bottom-20px"><i class="fas fa-check-circle font-size-30px g"></i> Appointment is Booked Successfully !</label>
              </div>

            </div>
            <div class="offset-md-3 col-md-9 padding-left-0px">
              <div class="row">
                <div class="offset-md-3 col-md-3">
                  <button class="btn btn-primary hover1 nav-link-hand font-size-16px width margin-top-10" (click)="ModalClose()" type="button">Done</button>

                </div>



              </div>
            </div>




          </div>

        </div>
      </div>
    </div>

  </div>

</div>



<div class="row margin-right-0px" *ngIf="GuestPatient">
  <div class="col-md-12 padding-right-0px background-white">
    <div class="card">

      <div class="card-header background-white pad1">
        <div class="row">
          <div class="col-md-3">
            <label class="title font-size-20px margin-top-0px margin-bottom-0px">Book Appointment</label>
          </div>
          <div class="offset-md-6 col-md-3">
            <label class="title font-size-14px margin-top-0px margin-bottom-0px labcolor">(Step 2 of 4)</label>
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>

      <div class="card-header background-white pad1">
        <div class="row margin-bottom-8px">
          <div class="col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3 padding-top-15px">
            <div class="row a1">
              <label class="margin-bottom-0px f2">{{SelectedDoctor.DisplayName}}</label>
            </div>
            <!--<div class="row a1">
              <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
            </div>-->
            <div class="row a1">
              <label class="margin-bottom-0px f3">{{SelectedDoctor.Specialty}}</label>
            </div>

          </div>
          <div class="col-md-3 padding-top-15px">
            <div class="row">
              <label class="margin-bottom-0px f2">Appointment</label>
            </div>
            <div class="row">
              <label class="margin-bottom-0px">{{ProviderAvlSlotsController.StartDateShort | date: 'shortDate'}}</label>
            </div>
            <div class="row">
              <label class="margin-bottom-0px">{{ProviderAvlSlotsController.StartDate | date: 'shortTime'}}</label>
            </div>

          </div>

        </div>


      </div>

      <div class="card-body background-white  padding-left-0px padding-top-0px">
        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px b2 margin-bottom-10px">

          <div class="row">


            <div class="col-md-12 margin-bottom-20px">

              <div class="row">
                <label class="font-size-20px margin-bottom-5px margin-top-10">Patient Details</label>
              </div>
              <div class="row my-pro-form margin-t-form">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Name </label>
                    </div>
                    <div class="col-md-6">

                      <!--<input type="text" class="form-control form-control-patient font-size-20px"
                             name="SaveAppoinmentRequestNew.PatientName" [(ngModel)]="SaveAppoinmentRequestNew.PatientName"
                             placeholder="Name">-->
                      <input type="text" class="form-control form-control-patient font-size-20px" placeholder="First Name"
                             id="SaveAppoinmentRequestNew.PatientName"
                             [(ngModel)]="SaveAppoinmentRequestNew.PatientName"
                             name="SaveAppoinmentRequestNew.PatientName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                             maxlength="30" minlength="1" #DisplayName="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                      <small class="form-text text-danger"
                             *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>

                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Phone Number </label>
                    </div>
                    <div class="col-md-6">

                      <input type="tel" class="form-control form-control-patient font-size-20px"
                             name="SaveAppoinmentRequestNew.Telephone" [(ngModel)]="SaveAppoinmentRequestNew.Telephone"
                             mask="(000) 000-0000" placeholder="Phone Number">
                      <!--<small class="form-text text-danger"
                             *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->


                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Email </label>
                    </div>
                    <div class="col-md-6">

                      <!--<input type="text" class="form-control form-control-patient font-size-20px"
                             name="SaveAppoinmentRequestNew.Email" [(ngModel)]="SaveAppoinmentRequestNew.Email"
                             placeholder="Email">-->
                      <input type="email" class="form-control form-control-patient font-size-20px" id="SaveAppoinmentRequestNew.Email"
                             [(ngModel)]="SaveAppoinmentRequestNew.Email"
                             name="SaveAppoinmentRequestNew.Email"
                             placeholder="Email" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                             #Email="ngModel" maxlength="30" minlength="4">
                      <small class="form-text text-danger"
                             *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>

                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Age </label>
                    </div>
                    <div class="col-md-2">

                      <input type="text" class="form-control form-control-patient font-size-20px"
                             name="SaveAppoinmentRequestNew.Age" [(ngModel)]="SaveAppoinmentRequestNew.Age"
                             placeholder="Age" maxlength="3">


                    </div>
                    <div class="col-md-1 text-align-right">
                      <label class="lab-size1"> Sex </label>
                    </div>
                    <div class="col-md-3 margin-top-7px">
                      <CodeTypeValue CodeType="SEX" id="SaveAppoinmentRequestNew.Gender"
                                     [(ngModel)]="SaveAppoinmentRequestNew.Gender" SelectedValue=""
                                     name="SaveAppoinmentRequestNew.Gender">

                      </CodeTypeValue>
                    </div>
                  </div>

                </div>
              </div>

              <!--<div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Sex </label>
                    </div>
                    <div class="col-md-6">
                      <CodeTypeValue CodeType="SEX" id="SaveAppointmentRequest.Gender"
                                     [(ngModel)]="SaveAppointmentRequest.Gender" SelectedValue=""
                                     name="SaveAppointmentRequest.Gender">

                      </CodeTypeValue>




                    </div>


                  </div>

                </div>
              </div>-->























            </div>



          </div>

        </div>
        <div class="row margin-top-15px margin-top-30px margin-bottom-30px">

          <div class="col-md-6">
            <button class="btn bs hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px float-right" (click)="BacktoList()" type="button">Back</button>
          </div>
          <div class="col-md-6 padding-left-0px padding-right-24px">
            <button class="btn btn-primary hover1 nav-link-hand font-size-14px width3 padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px float-left"
                    (click)="regconfirm1()" type="button">
              Proceed
            </button>

          </div>




        </div>
      </div>
    </div>
  </div>

</div>


<div class="row margin-right-0px" *ngIf="Regconfirm1">
  <div class="col-md-12  background-white">
    <div class="card">
      <div class="card-header background-white pad1">

        <div class="row margin-bottom-8px">
          <div class="col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3 padding-top-15px">
            <div class="row a1">
              <label class="margin-bottom-0px f2">{{SelectedDoctor.DisplayName}}</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">{{SelectedDoctor.Specialty}} <!--DM, MD, MBBS--></label>
            </div>
            <!--<div class="row a1">
              <label class="margin-bottom-0px f3">--</label>
            </div>-->

          </div>
          <div class="offset-md-4 col-md-3">
            <label class="title font-size-14px margin-top-0px margin-bottom-0px labcolor">(Step 3 of 4)</label>
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

        </div>


      </div>

      <div class="card-body background-white padding-left-0px padding-top-0px">


        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px margin-bottom-10px">

          <div class="row">
            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px c3">
              <div class="row">
                <div class="col-md-12 padh1 padding-left-15px">

                  <div class="row">

                    <div class="col-md-4">
                      <div class="row a1">
                        <label class="margin-bottom-0px f2">Appointment</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-0px">{{ProviderAvlSlotsController.StartDateShort | date: 'dd-MMM-yyyy'}}</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-5px">{{ProviderAvlSlotsController.StartDate | date: 'shortTime'}}</label>
                      </div>
                    </div>

                    <div class="col-md-4 paddin-left-5px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px font-weight-bold font-size-18px color-Assign">{{SaveAppoinmentRequestNew.PatientName }}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px">{{SaveAppoinmentRequestNew.Gender}},{{SaveAppoinmentRequestNew.Age}}  Years</label>
                      </div>
                    </div>

                    <div class="col-md-4 padding-left-0px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient Contact</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px"><i class="fas fa-phone"></i> : {{SaveAppoinmentRequestNew.Telephone}}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px"><i class="fas fa-envelope"></i> : {{SaveAppoinmentRequestNew.Email}}</label>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
            <div class="row col-md-12 margin-left-zero margin-right-0px background-bordercolor">
              <div class="col-md-4 margin-left-auto margin-top-5px margin-bottom-5px">
                <div>
                  <CodeTypeValue CodeType="VST"
                                 id="SaveAppoinmentRequestNew.VisitType"
                                 [(ngModel)]="SaveAppoinmentRequestNew.VisitType" SelectedValue="SaveAppoinmentRequestNew.VisitType"
                                 name="SaveAppoinmentRequestNew.VisitType">
                  </CodeTypeValue>
                </div>
              </div>
              <div class="col-md-4 margin-right-auto margin-top-5px margin-bottom-5px">
                <div>
                  <CodeTypeValue CodeType="CNSTY"
                                 id="SaveAppoinmentRequestNew.ConsultationType"
                                 [(ngModel)]="SaveAppoinmentRequestNew.ConsultationType" SelectedValue="SaveAppoinmentRequestNew.ConsultationType"
                                 name="SaveAppoinmentRequestNew.ConsultationType">
                  </CodeTypeValue>
                </div>
              </div>
              <!--<div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <CodeTypeValue CodeType="VST"
                                   id="SaveAppoinmentRequestNew.VisitType"
                                   [(ngModel)]="SaveAppoinmentRequestNew.VisitType" SelectedValue="SaveAppoinmentRequestNew.VisitType"
                                   name="SaveAppoinmentRequestNew.VisitType">
                    </CodeTypeValue>
                  </div>
                  <div class="col-md-4">
                    <CodeTypeValue CodeType="CNSTY"
                                   id="SaveAppoinmentRequestNew.ConsultationType"
                                   [(ngModel)]="SaveAppoinmentRequestNew.ConsultationType" SelectedValue="SaveAppoinmentRequestNew.ConsultationType"
                                   name="SaveAppoinmentRequestNew.ConsultationType">
                    </CodeTypeValue>
                  </div>
                </div>
              </div>-->



            </div>


            <div class="col-md-12">
              <div class="row margin-top-30px margin-bottom-30px">

                <div class="col-md-6 padding-left-0px padding-right-24px">
                  <button class="btn bs hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px float-right" (click)="Back3()" type="button">Back</button>
                </div>
                <div class="col-md-6 padding-left-0px padding-right-24px">
                  <button class="btn btn-primary hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px float-left" (click)="Confirm1()" type="button" *ngIf='isvisible'>Book</button>
                </div>

              </div>

            </div>




          </div>

        </div>
      </div>
    </div>

  </div>

</div>


<div class="row margin-right-0px" *ngIf="Final1">
  <div class="col-md-12 padding-right-0px background-white">
    <div class="card">
      <div class="card-header background-white pad1">

        <div class="row margin-bottom-8px">
          <div class="col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3 padding-top-15px">
            <div class="row a1">
              <label class="margin-bottom-0px f2">{{SelectedDoctor.DisplayName}}</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">{{SelectedDoctor.Specialty}}</label>
            </div>
            <!--<div class="row a1">
              <label class="margin-bottom-0px f3"></label>
            </div>-->

          </div>
          <div class="offset-md-4 col-md-3">
            <label class="title font-size-14px margin-top-0px margin-bottom-0px labcolor">(Step 4 of 4)</label>
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

        </div>


      </div>

      <div class="card-body background-white padding-left-0px padding-top-0px">


        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px margin-bottom-10px">

          <div class="row">
            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px c3">
              <div class="row">
                <div class="col-md-12 padding-left-15px padh1">

                  <div class="row">

                    <div class="col-md-4">
                      <div class="row a1">
                        <label class="margin-bottom-0px f2">Appointment</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-0px">{{ProviderAvlSlotsController.StartDateShort | date: 'dd-MMM-yyyy'}}</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-0px">{{ProviderAvlSlotsController.StartDate | date: 'shortTime'}}</label>

                      </div>
                    </div>

                    <div class="col-md-4 paddin-left-5px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px font-weight-bold font-size-18px color-Assign">{{SaveAppoinmentRequestNew.PatientName }}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px">{{SaveAppoinmentRequestNew.Gender}},{{SaveAppoinmentRequestNew.Age}}  Years</label>
                      </div>
                    </div>

                    <div class="col-md-4 padding-left-0px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient Contact</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px"><i class="fas fa-phone"></i> : {{SaveAppoinmentRequestNew.Telephone}}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px"><i class="fas fa-envelope"></i> : {{SaveAppoinmentRequestNew.Email}}</label>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div class="offset-md-3 col-md-9 padding-left-0px">

              <div class="row">
                <label class="font-size-20px margin-left-22px margin-top-30px margin-bottom-20px label-color-kn"><i class="fas fa-check-circle font-size-30px g"></i> Appointment is Booked Successfully !</label>
              </div>

            </div>
            <div class="offset-md-3 col-md-9 padding-left-0px">
              <div class="row">
                <div class="offset-md-3 col-md-3">
                  <button class="btn btn-primary hover1 nav-link-hand font-size-16px width margin-top-10" (click)="ModalClose()" type="button">Done</button>

                </div>



              </div>
            </div>




          </div>

        </div>
      </div>
    </div>

  </div>

</div>
